import { useEffect, useRef, useState } from 'react';
import { useAnimationStore } from 'store/animation';

export default function useFlyingAnimation() {
  // store
  const { targetRef } = useAnimationStore(); // 헤더에서 사용

  // state
  const [animationKey, setAnimationKey] = useState(0);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [isFlying, setIsFlying] = useState(false);
  const [flyStyle, setFlyStyle] = useState({
    top: 0,
    left: 0,
    midX: 0,
    midY: 0,
    endTop: 0,
    endLeft: 0,
  });
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleClick = () => {
    const start = buttonRef?.current?.getBoundingClientRect();
    const end = targetRef?.current?.getBoundingClientRect();
    if (!start || !end) return;

    const midX = (start.left + end.left) / 2;
    const midY = Math.min(start.top, end.top);

    setFlyStyle({
      top: start.top + start.height / 2,
      left: start.left + start.width / 2,
      midX,
      midY,
      endTop: end.top,
      endLeft: end.left,
    });

    setAnimationKey((prev) => prev + 1);
    setIsFlying(true);

    timerRef.current = setTimeout(() => {
      setIsFlying(false);
    }, 1000);
  };

  return {
    animationKey,
    isFlying,
    flyStyle,
    buttonRef,
    handleClick,
  };
}
